import axiosInstance from "@/axiosInstance";
export default {
  mounted() {
    this.fetchAllDevelopersData();
    this.fetchAllProjectData();
    this.fetchAllRateName();
    // this.fetchAllServiceData();
    this.fetchAllPropertyType();
    this.fetchAllProvinces();
    this.fetchAllCities();
    this.fetchAllBrgys();
    this.fetchCityByProvince();
    this.fetchBrgyByCities();
    this.fetchAllFeatures();
    this.fetchAllProjectCommission();
  },
  methods: {
    handleDeveloperAdded(updatedDeveloper) {
      const existingDeveloperIndex = this.devs.findIndex(
        (dev) => dev.id === updatedDeveloper.id
      );
      if (existingDeveloperIndex !== -1) {
        this.$set(this.devs, existingDeveloperIndex, updatedDeveloper);
      } else {
        this.devs.push(updatedDeveloper);
      }
    },

    handleRateAdded(updatedRate) {
      const existingRateIndex = this.devs.findIndex(
        (rate) => rate.id === updatedRate.id
      );
      if (existingRateIndex !== -1) {
        this.$set(this.rates, existingRateIndex, updatedRate);
      } else {
        this.devs.push(updatedRate);
      }
    },
    fetchAllDevelopersData() {
      axiosInstance
        .get("developers/")
        .then((response) => {
          this.devs = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchAllProjectData() {
      axiosInstance
        .get("projects/")
        .then((response) => {
          this.pros = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    // fetchProjectByDeveloper(developerId) {
    //   if (developerId) {
    //     const filteredProjects = this.pros.filter(
    //       (pro) => pro.developer === developerId
    //     );

    //     // Loop through all projectsss in this.pros and assign the filtered projects to each one
    //     this.pros.forEach((pro) => {
    //       if (pro.developer === developerId) {
    //         pro.projectOptions = filteredProjects.map((filteredPro) => ({
    //           value: filteredPro.id,
    //           label: filteredPro.property_name,
    //         }));
    //       }
    //     });
    //   }
    // },
    fetchAllRateName() {
      axiosInstance
        .get("rate-names/")
        .then((response) => {
          this.rate_names = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    //Listings
    fetchAllPropertyType() {
      axiosInstance
        .get("property-type/")
        .then((response) => {
          this.pro_type = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchAllProvinces() {
      axiosInstance
        .get("provinces/")
        .then((response) => {
          this.provinces = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchAllCities() {
      axiosInstance
        .get("cities/")
        .then((response) => {
          this.cities = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchAllBrgys() {
      axiosInstance
        .get("brgy/")
        .then((response) => {
          this.brgys = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchCityByProvince(provinceId) {
      if (provinceId) {
        const filteredCities = this.cities.filter(
          (mun) => mun.province === provinceId
        )
        this.cityOptions = filteredCities.map((city) => ({
          value: city.id,
          label: city.city_name
        }))
      }
    },
    fetchBrgyByCities(cityId) {
      if (cityId) {
        const filteredBrgy = this.brgys.filter(
          (br) => br.city === cityId
        )
        this.brgyOptions = filteredBrgy.map((brg) => ({
          value: brg.id,
          label: brg.brgy_name
        }))
      }
    },
    fetchAllFeatures() {
      axiosInstance
        .get("features/")
        .then((response) => {
          this.feature_data = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    },
    fetchAllProjectCommission() {
      axiosInstance
        .get("project-commissions/")
        .then((response) => {
          this.proj_comm = response.data;
          this.setPages();
        })
        .catch((error) => {
          console.error("Error fetching posts:", error);
        });
    }
  },
};